import React, { useEffect, useState } from "react";
import { Text, View } from "react-native";

import AppMessages from "../../../../config/AppMessages";
import ImageComponent from "../../common/ImageComponent";
import ManaButton from "../../common/ManaButton";

import {
  getStorageItem,
  getStorageKey,
  navigate,
  setStorageItem,
} from "../../../../helpers/utils.js";
import cardStyles from "../cards/cardStyles";
import CloseIcon from "../../common/dialog/CloseIcon";

export default function WelcomeCard({ controller }) {
  const [showCard, setShowCard] = useState(true);

  useEffect(() => {
    getStorageItem(getStorageKey(controller, "card:welcome")).then((data) => {
      if (data && !data.show) {
        setShowCard(false);
      }
    });
  }, []);

  const hideCard = () => {
    setShowCard(false);
    setStorageItem(getStorageKey(controller, "card:welcome"), {
      show: false,
    });
  };

  const onButtonPress = () => {
    const action = {
      action: "save",
      target: "scheduled_call",
    };

    controller.tracking.track("Schedule Call");
    controller.cardAction(action);
    navigate(controller, "rn:appointment");
  };

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 110 }]}>
        <CloseIcon onPress={() => hideCard()} style={cardStyles.closeButton} />

        <View style={[cardStyles.cardContent]}>
          <ImageComponent
            image={require("../../../../assets/home/welcomeIcon.png")}
            style={[{ width: 79, height: 79, marginRight: 10 }]}
          />

          <View style={{ flex: 1 }}>
            <Text style={cardStyles.title}>Welcome!</Text>
            <Text style={cardStyles.cardTextThin}>
              {AppMessages.WelcomeToMana}
            </Text>

            <ManaButton
              onPress={onButtonPress}
              style={[
                cardStyles.buttonSmall,
                {
                  marginTop: 8,
                  width: 138,
                },
              ]}
              styleText={cardStyles.buttonSmallText}
              text="Schedule Free Call"
            />
          </View>
        </View>
      </View>
    </View>
  );
}
